export default __webpack_public_path__ + "static/media/chat_general.a4e2f9e5.jpg";